<template>
  <ElDialog
    :title="$t('RANGEFITLER.CHANGE_RANGE')"
    :visible="value"
    width="30%"
    @close="closeAndReset"
  >
    <ElForm ref="rangeForm" :model="range">
      <ElFormItem :label="$t('FROM_DATE')">
        <UiDatePicker :default-date="currentDate" @select-date="setStartDate" />
      </ElFormItem>

      <ElFormItem :label="$t('TO_DATE')">
        <UiDatePicker :default-date="currentDate" @select-date="setEndDate" />
      </ElFormItem>

      <ElButton type="primary" @click.native.prevent="emitSave">
        {{ $t('SAVE') }}
      </ElButton>
    </ElForm>
  </ElDialog>
</template>

<script>
import UiDatePicker from '@@/layout/UiDatePicker';

import form from '@/mixins/form';
import modal from '@/mixins/modal';

export default {
  name: 'RangeFilterModal',

  components: {
    UiDatePicker,
  },

  mixins: [form, modal],

  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      range: {
        startDate: '',
        endDate: '',
      },
    };
  },

  computed: {
    currentDate() {
      return Date.now();
    },
    rangeString() {
      return `${this.range.startDate},${this.range.endDate}`;
    },
  },

  methods: {
    emitSave() {
      this.$emit('save', this.rangeString);
      this.closeAndReset();
    },
    closeAndReset() {
      this.resetForm('rangeForm');
      this.$emit('input', false);
    },
    setStartDate(selectedDate) {
      this.range.startDate = selectedDate;
    },
    setEndDate(selectedDate) {
      this.range.endDate = selectedDate;
    },
  },
};
</script>
